import Typography from "@material-ui/core/Typography";
import GenericDialog from "../../../../../../../../../ui/dialogs/generic-dialog/GenericDialog";
import PropTypes from "prop-types";
import {useTheme} from "@material-ui/core/styles";

const QuantitaSuperataDialog = (props) => {
    const theme = useTheme()

    const dialogContent = (
        <Typography variant="body2" style={{color: theme.palette.font.light}}>
            Hai selezionato un numero di SIM superiore alla quantità disponibile per questa offerta
        </Typography>
    );

    const dialogActions = (
        <></>
    );

    return (
        <GenericDialog dialogWidth="xs"
                       open={props.open}
                       handleDialogClose={props.handleDialogClose}
                       handleDialogCloseButton={props.handleDialogClose}
                       dialogActions={dialogActions}
                       dialogContent={dialogContent}>
            <Typography variant={"h6"}>
                Quantità disponibile superata
            </Typography>
        </GenericDialog>
    )
}

QuantitaSuperataDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleDialogClose: PropTypes.func.isRequired
}


export default QuantitaSuperataDialog